import classNames from 'classnames';
import EcoImg from 'eco-design/base/eco-img';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import 'swiper/scss';
import 'swiper/scss/navigation';
import './index.scss';
import React, { useEffect, useState, useRef } from 'react';
import EfScrollAni from '@/efscrollani';
import EcoSpace from 'eco-design/base/eco-space';
import { useLang } from '@/i18n';
import useCardsShowHook from '../useHooks/useCardsShowHook';

interface ItfAniArrItem {
    name: string;
    cls: string;
}

export default function Content({ type }: { type: string }) {
    // const { items = [] as ItfKspSwiperItem[], theme, title, titleColor } = data as ItfKspSwiperData;
    const prefixCls = 'ksp-swiper';
    const [typeNumber, setTypeNumber] = useState<'narrow' | 'wide' | ''>('narrow'); // narrow: 4个及以上，wide: 4个以下
    const theme = 'white';
    const [gap, setGap] = useState<number>(10);
    const { t } = useLang('business');
    const { t: s } = useLang('business.D');
    const items: { [key: string]: any } = {
        [t('tab_title_1')]: [
            {
                name: s('tab1_title_1'),
                nameColor: '#fff',
                pc: 'https://websiteoss.ecoflow.com/upload/image/1766383256627/ksp-1.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1766383257370/ksp-h5-1.jpg',
            },
            {
                name: s('tab1_title_2'),
                nameColor: '#fff',
                pc: 'https://websiteoss.ecoflow.com/upload/image/1766383256959/ksp-2.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1766383257155/ksp-h5-2.jpg',
            },
            {
                name: s('tab1_title_3'),
                nameColor: '#fff',
                pc: 'https://websiteoss.ecoflow.com/upload/image/1766383256758/ksp-3.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1766383258375/ksp-h5-3.jpg',
            },
            {
                name: s('tab1_title_4'),
                nameColor: '#fff',
                pc: 'https://websiteoss.ecoflow.com/upload/image/1766383257784/ksp-4.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1766383258195/ksp-h5-4.jpg',
            },
            {
                name: s('tab1_title_5'),
                nameColor: '#fff',
                pc: 'https://websiteoss.ecoflow.com/upload/image/1766383257569/ksp-5.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1766383257985/ksp-h5-5.jpg',
            },
        ],
        [t('tab_title_2')]: [
            {
                name: s('tab2_title_1'),
                nameColor: '#fff',
                pc: 'https://websiteoss.ecoflow.com/upload/image/1766375118810/2-ksp-1.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1766375120646/2-ksp-h5-1.jpg',
            },
            {
                name: s('tab2_title_2'),
                nameColor: '#fff',
                pc: 'https://websiteoss.ecoflow.com/upload/image/1766375119814/2-ksp-2.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1766375120768/2-ksp-h5-2.jpg',
            },
            {
                name: s('tab2_title_3'),
                nameColor: '#fff',
                pc: 'https://websiteoss.ecoflow.com/upload/image/1766375120523/2-ksp-3.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1766375121031/2-ksp-h5-3.jpg',
            },
            {
                name: s('tab2_title_4'),
                nameColor: '#000',
                pc: 'https://websiteoss.ecoflow.com/upload/image/1766375119616/2-ksp-4.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1766375119219/2-ksp-h5-4.jpg',
            },
            {
                name: s('tab2_title_5'),
                nameColor: '#fff',
                pc: 'https://websiteoss.ecoflow.com/upload/image/1766375119025/2-ksp-5.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1766375119412/2-ksp-h5-5.jpg',
            },
        ],
        [t('tab_title_3')]: [
            {
                name: s('tab3_title_1'),
                nameColor: '#fff',
                pc: 'https://websiteoss.ecoflow.com/upload/image/1766383351008/3-ksp-1.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1766383351599/3-ksp-h5-1.jpg',
            },
            {
                name: s('tab3_title_2'),
                nameColor: '#fff',
                pc: 'https://websiteoss.ecoflow.com/upload/image/1766383352220/3-ksp-2.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1766383351371/3-ksp-h5-2.jpg',
            },
            {
                name: s('tab3_title_3'),
                nameColor: '#fff',
                pc: 'https://websiteoss.ecoflow.com/upload/image/1766383352006/3-ksp-3.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1766383351185/3-ksp-h5-3.jpg',
            },
            {
                name: s('tab3_title_4'),
                nameColor: '#fff',
                pc: 'https://websiteoss.ecoflow.com/upload/image/1766383351820/3-ksp-4.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1766383352449/3-ksp-h5-4.jpg',
            },

        ],
    };
    const [enter, setEnter] = useState({
        title: 'false',
        content: 'false',
    });

    // 新增：用于记录状态的ref
    const scrollLockRef = useRef({
        isLocked: false,
        scrollTop: 0,
        scrollbarWidth: 0,
        originalScrollBehavior: '',
        originalBodyPaddingRight: '',
        originalBodyOverflow: '',
    });

    if (typeof window !== 'undefined') {
        if (!window?.AniContainer) {
            window.AniContainer = new EfScrollAni();
        }
    }

    // 新增：无感知滚动解锁函数
    const unlockScroll = () => {
        if (!scrollLockRef.current.isLocked) return;

        const html = document.documentElement;
        const body = document.body;
        const { scrollTop } = scrollLockRef.current;

        // 1. 恢复滚动行为
        html.style.scrollBehavior = scrollLockRef.current.originalScrollBehavior;

        // 2. 移除锁定样式
        body.style.overflow = scrollLockRef.current.originalBodyOverflow;
        body.style.position = '';
        body.style.top = '';
        body.style.left = '';
        body.style.right = '';
        body.style.width = '';
        body.style.paddingRight = scrollLockRef.current.originalBodyPaddingRight;

        // 3. 在下一帧恢复滚动位置（无感知）
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                // 双重requestAnimationFrame确保DOM已更新
                window.scrollTo({
                    top: scrollTop,
                    // @ts-ignore
                    behavior: 'instant', // 或 'auto'
                });

                // 额外确保一次（防止某些浏览器问题）
                setTimeout(() => {
                    window.scrollTo({
                        top: scrollTop,
                        // @ts-ignore
                        behavior: 'instant',
                    });
                }, 16);

                scrollLockRef.current.isLocked = false;
            });
        });
    };

    // 新增：处理浏览器前进后退按钮
    // useEffect(() => {
    //     if (typeof window === 'undefined') return;

    //     const handlePopState = () => {
    //         if (scrollLockRef.current.isLocked) {
    //             unlockScroll();
    //         }
    //     };

    //     window.addEventListener('popstate', handlePopState);

    //     return () => {
    //         window.removeEventListener('popstate', handlePopState);
    //     };
    // }, []);

    // useEffect(() => {
    //     if (typeof window !== 'undefined' && window?.AniContainer) {
    //         const scenes: any[] = [];
    //         const arr: ItfAniArrItem[] = [
    //             { name: 'title', cls: 'info-title' },
    //             { name: 'content', cls: 'swiper' },
    //         ];
    //         arr.map((item: ItfAniArrItem) => {
    //             scenes.push(
    //                 AniContainer.create({
    //                     triggerElement: `.editor-${prefixCls} .${prefixCls}-${item.cls}`,
    //                     triggerHook: 1,
    //                     offset: '25%',
    //                     onEnter: () => {
    //                         setEnter((prev: any) => ({ ...prev, [item?.name]: true }));
    //                     },
    //                 }),
    //             );
    //         });
    //         return () => scenes.forEach((scene: any) => scene.destory());
    //     }
    // }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (typeNumber === 'wide') {
                setGap(window.innerWidth > 1024 ? 12 : 10);
            } else if (typeNumber === 'narrow') {
                setGap(window.innerWidth > 1440 ? 12 : 10);
            }
        }
    }, []);

    // useEffect(() => {
    //     setTypeNumber(items[type]?.length >= 4 ? 'narrow' : items[type]?.length >= 1 ? 'wide' : '');
    // }, [items]);

    // 新增：组件卸载时清理
    // useEffect(() => {
    //     return () => {
    //         if (scrollLockRef.current.isLocked) {
    //             unlockScroll();
    //         }
    //     };
    // }, []);
    useCardsShowHook('.editor-ksp-swiper .dynamic', '.editor-ksp-swiper');


    return (
        <div className={`editor-${prefixCls}  theme-${theme} type-${typeNumber} ${s('title')}-business-D GtmModuleData-section`}
            id={`${s('title')}-business-D`}
            data-section-id={`${s('title')}-business-D`}
            data-section-title={`${s('title')}-business-D`}
        >

            <EcoSpace />
            <div className={`${prefixCls}-info dynamic`}>

                <div className={`${prefixCls}-info-title `} style={{ color: '#000' }} >
                    {s('title')}
                </div>

            </div>
            <Swiper
                key={typeNumber}
                className={`${prefixCls}-swiper`}
                initialSlide={0}
                spaceBetween={gap}
                slidesPerView={'auto'}
                modules={[Navigation]}
                navigation={items?.[type]?.length > 1}

            >
                {items?.[type]?.map((item, index: number) => {
                    const { name, nameColor, text, textColor, pc, h5 } = item;
                    const itemClasses = classNames({
                        [`${prefixCls}-swiper-item`]: true,
                        [`${prefixCls}-swiper-item-${index}`]: true,
                    });
                    return (
                        <SwiperSlide className={`${itemClasses} dynamic`} key={`${index}`}>
                            <div className={`${prefixCls}-swiper-item-inner`} data-btn-id={item.name} >
                                <div className={`${prefixCls}-swiper-item-img`}>
                                    <EcoImg pc={pc} h5={h5} />
                                </div>
                                <div className={`${prefixCls}-swiper-item-content`}>
                                    {name && (
                                        <div className={`${prefixCls}-swiper-item-content-name`} style={{ color: nameColor || '' }} title={name}>
                                            {name}
                                        </div>
                                    )}
                                    {text && (
                                        <div className={`${prefixCls}-swiper-item-content-text`} style={{ color: textColor || '' }} title={text}>
                                            {text}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </div>
    );
}
